var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{attrs:{"id":"zhaw-progress-bar","value":_vm.progressValue,"variant":"primary","striped":"","animated":_vm.isAnimated}})}
var staticRenderFns = []

export { render, staticRenderFns }